import { GetMembershipDetails } from '../contracts';
import axios, { AxiosError } from 'axios';
import { createAxiosConfig } from '../apiHelpers';
import LogCannon from '@ace-clublabs/log-cannon';
import StatusCode from 'status-code-enum';

export const GetMembershipDetailsApi =
  (endpoint: string): GetMembershipDetails =>
  async () => {
    try {
      const config = { ...createAxiosConfig(endpoint) };
      const response = await axios.post(endpoint, {}, config);

      LogCannon.blast('Get Membership Details  success');
      return Promise.resolve(response.data.data);
    } catch (e: any | AxiosError) {
      if (e.message === '') {
        return Promise.resolve({ status: 'cancel' });
      }

      const errorResponse = e?.response?.data?.error;
      LogCannon.blast('Get Membership Details error', errorResponse);
      return Promise.resolve({
        status: 'error',
        error: {
          code: e?.response?.status || StatusCode.ServerErrorInternal,
          message: 'Get Membership Details failed',
          ...errorResponse,
        },
      });
    }
  };
